import React from 'react';
import './index.scss';
import * as m from '../../../../translations/mapping';
import { mapT } from '../../../../translations/utils';
import { COLORS } from '../constants';
import { withTranslation } from 'react-i18next';

const Legend = (props) => {
    const { selected, t } = props;
    return (
        <div className="role-breakdown__legend">
            {
                Object.values(selected).map((group, i) => {
                    return(
                        <>
                            <div 
                            className="role-breakdown__legend legend-line"
                            style={{ backgroundColor: COLORS[i] }}>
                            </div>
                            <div
                            key={i}
                            className={`role-breakdown__legend legend-group`}>
                                {mapT(m.GROUP_DOM_NONDOM, group)}
                            </div>
                        </>
                    )
                })
            }
        </div>
    );
}

export default withTranslation()(Legend);
